<template>
    <main role="main" class="container text-center">
        <h1>My Jobs</h1>
        <notices :errors="errors" :notices="notices"></notices>
        <router-link to="/job" class="btn btn-primary">Create New Job</router-link>
        <table class="table" style="margin-top: 20px;" v-if="jobsLoaded && schedules.length > 0">
            <tr>
                <th>Job Name</th>
                <th>Schedule</th>
                <th>Next Run</th>
                <th>Action</th>
            </tr>
            <tr v-bind:key="schedule" v-for="schedule of schedules">
                <td v-bind:class="[!schedule.enabled ? 'scheduleDisabled' : '']"><router-link v-bind:to="'/job/edit/' + schedule.id">{{schedule.name}}</router-link>
                    &nbsp;<span v-if="!schedule.enabled" class="badge badge-pill badge-light">Paused</span>
                </td>
                <td v-bind:class="[!schedule.enabled ? 'scheduleDisabled' : '']">{{schedule.intervalText}}</td>
                <td v-bind:class="[!schedule.enabled ? 'scheduleDisabled' : '']">{{schedule.nextRunDate.toLocaleDateString()}} {{schedule.nextRunDate.toLocaleTimeString()}}</td>
                <td>
                    <button class="btn btn-outline-primary btn-sm" @click="toggleSchedule(schedule.id)"><b-icon icon="toggles" font-scale="1.5" v-b-tooltip.hover title="Toggle on/off"></b-icon></button>&nbsp;
                    <!-- <router-link class="btn btn-outline-primary btn-sm" v-bind:to="'/job/edit/' + schedule.id"><b-icon icon="gear" font-scale="1.5" v-b-tooltip.hover title="Modify Schedule"></b-icon></router-link>&nbsp; -->
                    <a class="btn btn-outline-primary btn-sm" :href="schedule.url" target="_blank"><b-icon icon="window" font-scale="1.5" v-b-tooltip.hover title="Go to Website"></b-icon></a>&nbsp;
                    <button class="btn btn-outline-danger btn-sm" @click="deleteSchedule(schedule.id)"><b-icon icon="trash" font-scale="1.5" v-b-tooltip.hover title="Delete Schedule"></b-icon></button>&nbsp;
                </td>
            </tr>
        </table>
        <p v-else-if="jobsLoaded && schedules.length == 0">You have no jobs yet. <router-link v-bind:to="'/job'">Create your first job.</router-link></p>
    </main>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
import Notices from '../components/Notices.vue';
import CommonMixin from '../util/common';
import AppConfig from '../util/config';

export default {
    components: { Notices },
    name: 'Schedule',
    mixins: [CommonMixin],
    data() {
        return {
            schedules: [],
            jobsLoaded: false
        }
    },
    methods: {
        truncate: function(s) {
            return _.truncate(s, { 'length': 50 })
        },
        getSchedules() {
            var that = this;
            var intervalMapping = {
                'FIVE_MIN': 'every 5 minutes',
                'FIFTEEN_MIN': 'every 15 minutes',
                'HALF_HOUR': 'every half hour',
                'ONE_HOUR': 'every hour',
                'THREE_HOURS': 'every 3 hours',
                'SIX_HOURS': 'every 6 hours',
                'TWELVE_HOURS': 'every 12 hours',
                'ONE_DAY': 'once a day',
                'ONE_WEEK': 'once a week',
                'ONE_MONTH': 'once a month'
            }
            this.overlayOn();
            this.backendGet("/schedule").then(result => {
                this.overlayOff();
                that.schedules = _.each(result.data, function(o) { 
                    o.nextRunDate = new Date(o.nextRunTs * 1000);
                    o.intervalText = intervalMapping[o.interval];
                    });
                that.jobsLoaded = true;
            });
        },
        deleteSchedule(id) {
            this.notices = [];
            var that = this;
            this.$dialog.confirm('Are you sure you want to delete this schedule?').then(function() {
                that.backendDelete("/schedule/" + id).then(() => {
                    that.getSchedules();
                    that.notices.push("Schedule has been deleted")
                })
            });
        },
        toggleSchedule(id) {
            this.notices = [];
            var self = this;
            var config = {
                headers: { "Authorization": "bearer " + this.getCookie("token")  }
            };

            var currentSchedule = _.filter(self.schedules, { 'id': id })[0];
            var toggleValue = currentSchedule.enabled ? false : true;

            var data = {
                "id": id,
                "enabled": toggleValue
            }
            this.overlayOn();
            axios.patch(AppConfig.BACKEND_ENDPOINT + "/schedule", data, config)
            .then(() => {
                self.getSchedules();
                this.errors = [];
                self.notices.push("Schedule has been " + (toggleValue ? "enabled" : "disabled"))
                this.overlayOff();
            })
            .catch(e => {
                console.log(e);
                var error = e.response.data.error;
                if (error && error == "MAX_ACTIVE_SCHEDULES_QUOTA_EXCEEDED") {
                    this.errors.push("You have reached maximum number of active schedules. Try to disable one of currently active schedules first.");
                } else {
                    this.errors.push("Unknown error");
                }
                if (e.response.status === 403) {
                    this.$emit("authenticated", false);
                    this.$router.replace({ name: "home" });
                }
                window.scrollTo(0,0);
                this.overlayOff();
            });
        }
    },
    mounted() {
        this.getSchedules();
    }
}
</script>

<style scoped>
.scheduleDisabled {
    color:#CCCCCC;
}
#secure {
    background-color: #FFFFFF;
    border: 1px solid #CCCCCC;
    padding: 20px;
    margin-top: 10px;
}
</style>